import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import Typography from "../Typography";

type Story = GenericStory<React.ComponentProps<typeof Typography>>;

export default {
    title: "Typography/Typography",
    component: Typography
} as ComponentMeta<typeof Typography>;

const Template: Story = args => <Typography {...args}>Example text</Typography>;

export const Default = Template.bind({});

export const Colored = Template.bind({});
Colored.args = {
    color: "background-error-800"
};

export const Size = Template.bind({});
Size.args = {
    variant: "heading-x-small-semibold"
};

export const Link = Template.bind({});
Link.args = {
    as: "a",
    href: "#here"
};
